import styles from './InputGroup.module.css';
import { ReactNode } from 'react';

export const InputGroup = ({ children }: { children: ReactNode }) => (
  <div className={styles.inputgroupContainer}>{children}</div>
);
